import React from "react";
import { useNavigate } from "react-router-dom";
// import { pauseAudio } from "../CommonMethhods/CommonMethods";

function PageProgressBarPartner(props) {
  const { progress, partnerData } = props;

  const navigate = useNavigate()
  // function ProgressNav(to) {
  //   // pauseAudio()
  //   navigate(`/${to}`)

  // }

  const stepFields = {
    "partner/basic-details": ["email"],
    "partner/document-upload": [
      "pan",
      "nameOnPan",
      "dob",
      "aadharNumber",
      "address",
      "address2",
      "pincode",
      "city",
      "state"
    ],
    "partner/bank-details": ["bankAcNumber", "bankAcType", "ifscCode", "profession"],
    "partner/selfie-upload": ["selfie"],
  };

  const isStepComplete = (step) => {
    if (!partnerData) return false;
     
    const fields = stepFields[step] || [];
    return fields.every((field) => {
      const val = partnerData[field];
      return val !== "" && val !== null && val !== undefined;
    });
  };

   const ProgressNav = (to) => {
    if (!isStepComplete(to)) return;
    navigate(`/${to}`);
  };

  const steps = [
    { label: "Basic Details", path: "partner/basic-details" },
    { label: "Document Upload", path: "partner/document-upload" },
    { label: "Bank Details", path: "partner/bank-details" },
    { label: "Selfie Upload", path: "partner/selfie-upload" },
      ]; 

      console.log(partnerData, "partnerData");
      

  return (
    <>
      <ul className={`form-progress ${progress}`}>
      {/* <li className="form-progress-item">
          <a role="button" onClick={() => ProgressNav("partner/basic-details")} >
          Basic Details
          </a>
        </li>

        <li className="form-progress-item">
          <a role="button" onClick={() => ProgressNav("partner/document-upload")} >
            Document Upload  
          </a>
        </li>

        
        <li className="form-progress-item">
          <a role="button" onClick={() => ProgressNav("partner/bank-details")} >
          Bank Details
          </a>
        </li>

        <li className="form-progress-item">
          <a role="button" onClick={() => ProgressNav("partner/selfie-upload")} >
          Selfie Upload
          </a>
        </li> */}

        {steps.map((item, index) => {
        const stepComplete = isStepComplete(item.path);

        return (
          <li
            key={index}
            className={`form-progress-item ${!stepComplete ? "disabled" : ""}`}
          >
            <a
              role="button"
              onClick={() => stepComplete && ProgressNav(item.path)}
              style={{
                pointerEvents: stepComplete ? "auto" : "none",
                cursor: stepComplete ? "pointer" : "not-allowed",
                opacity: stepComplete ? 1 : 0.5,
              }}
            >
              {item?.label}
            </a>
          </li>
        );
      })}
        
      </ul>
    </>
  );
}

export default PageProgressBarPartner;
